import React from "react";

import { Row, RowCell, RowHeaderCell } from "../atoms";
import { ContentCellData } from "../cell-variants";

import { ContentCell } from "./content-cell.tsx";

interface ContentRowProps {
    row: ContentCellData[];
    rowKey: string | number;
    columnTitles: string[];
}

export const ContentRow: React.FC<ContentRowProps> = (
    props: ContentRowProps
) => {
    const { row, rowKey, columnTitles } = props;
    return (
        <Row key={rowKey}>
            {row.map((cell, cellIndex) =>
                cellIndex === 0 ? (
                    <RowHeaderCell key={cellIndex}>
                        <ContentCell isRowHeader={true} cellData={cell} />
                    </RowHeaderCell>
                ) : (
                    <RowCell
                        key={cellIndex}
                        // @ts-ignore
                        columnTitle={columnTitles[cellIndex]}
                    >
                        <ContentCell cellData={cell} />
                    </RowCell>
                )
            )}
        </Row>
    );
};
